import React, { useEffect, useState } from 'react'

import { BACKEND_PORT, BACKEND_URL } from '../../utils/const'
import Backend, { SORT_VALUES } from '../../api/backend'
import { numSpaces, strNumOnly } from '../../utils/functions'

import { FilterPanel } from '../../components/FilterPanel/FilterPanel'
import { CatCardGalery } from '../../components/CatCardGalery/CatCardGalery'
import { Pagination } from '../../components/Pagination/Pagination'
import { Preloader } from '../../components/Preloader/Preloader'

import './Gallery.scss'

const ITEMS_COUNT = 24

const SORT_TYPES = [
  SORT_VALUES.TOKEN_ID_ASC,
  SORT_VALUES.TOKEN_ID_DESC,
  SORT_VALUES.LOT_PRICE_ASC,
  SORT_VALUES.LOT_PRICE_DESC,
  SORT_VALUES.BID_ASC,
  SORT_VALUES.BID_DESC,
  SORT_VALUES.RANK_ASC,
  SORT_VALUES.RANK_DESC,
]

export const Gallery = () => {
  const [isLoading, setIsLoading] = useState(true)
  const [filterHide, setFilterHide]= useState(document.body.offsetWidth <= 635)
  const [searchID, setSearchID] = useState('')
  const [sort, setSort] = useState(-1)
  const [filter, setFilter] = useState({})
  const [pagination, setPagination] = useState({ offset: 0, count: ITEMS_COUNT })
  const [galery, setGalery] = useState({ count: 0, items: [] })

  useEffect(() => {
    const { offset, count } = pagination
    let isMount = true
    
    setIsLoading(true)

    new Backend(BACKEND_URL, BACKEND_PORT).searchImages(
      filter,
      searchID,
      false,
      false,
      0,
      0,
      SORT_TYPES[sort],
      offset,
      count
    ).then(res => {
      if (isMount) setGalery(res)
    })
    .catch(console.log)
    .finally(() => setIsLoading(false))

    return () => isMount = false
  }, [filter, searchID, sort, pagination, setGalery])

  const changeSearch = text => setSearchID(strNumOnly(text))

  const changeFilter = (key, value) => {
    const newFilter = { ...filter }
    if (newFilter[key]) {
      if (newFilter[key].includes(value)) {
        newFilter[key].splice(newFilter[key].indexOf(value), 1)
        if (newFilter[key].length === 0) delete newFilter[key]
      } else {
        newFilter[key].push(value)
      }
    } else {
      newFilter[key] = [ value ]
    }
    
    setFilter(newFilter)
  }

  const clearFilters = () => {
    setSearchID('')
    setSort(-1)
    setFilter({})
  }

  const onChangePage = page => setPagination(v => ({ ...v, offset: (page - 1) * ITEMS_COUNT }))

  return (
    <div className="gallery-container">
      <div className="content">
        <div className="side-panel">
          <FilterPanel
            hide={ filterHide }
            onToggle={ () => setFilterHide(v => !v) }
            search={ searchID }
            searchChange={ changeSearch }
            filter={ filter }
            filterChange={ changeFilter }
            sort={ sort }
            sortChange={ setSort }
            onClear={ clearFilters }
          />
        </div>
        {
          isLoading
          ? (
            <div className="preloader-container">
              <Preloader />
            </div>
          )
          : (
            <div className="images-container">
              <div className="count-title">
                <span>
                  { numSpaces(galery.count) } RESULT{ galery.count === 1 ? '' : 'S' } FOUND
                </span>
              </div>
              <div className="images-list">
                {
                  galery.items.map(item => (
                    <CatCardGalery
                      key={ item._id }
                      id={ item.tokenId }
                      routeTo="/gallery"
                    />
                  ))
                }
              </div>
              <div>
                <Pagination
                  start={ 1 }
                  end={ Math.ceil(galery.count / ITEMS_COUNT) }
                  selected={ pagination.offset / ITEMS_COUNT + 1 }
                  onClick={ onChangePage }
                />
              </div>
            </div>
          )
        }
      </div>
    </div>
  )
}